/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CenterNftRecordDialog.vue?vue&type=template&id=232de60e&scoped=true"
import script from "./CenterNftRecordDialog.vue?vue&type=script&lang=js"
export * from "./CenterNftRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./CenterNftRecordDialog.vue?vue&type=style&index=0&id=232de60e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232de60e",
  null
  
)

export default component.exports